import React, { useMemo, useState } from "react";
import styles from "../../assets/styles/Bills/Bills.module.scss";
import { AppPage, MimaTable, PageLoader, Searchbar } from "../../components";
import { date } from "../../utils/utils";
import { amountFormatter } from "../../utils/utils";
import { billsStore } from "../../stores";
import { AnimatePresence } from "framer-motion";
import { ReconBillsModalContainer } from "../../containers";
import moment from "moment";
import constant from "../../utils/constant";

const ReconBills = ({
  loading,
  billRecon,
  goToBillReconModal,
  closeModal,
  billItem,
  isLoading,
  data,
  isFetching,
  limit,
  onLimitChange,
  setFilterQuery,
  setSearchQuery,
  currentPage,
  setCurrentPage,
}) => {
  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.bills || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const subscriptionDate = cell.row.original?.createdAt;
        return (
          <span>{moment(subscriptionDate).format("DD/MM/YYYY HH:mm a")}</span>
        );
      },
    },
    {
      Header: "Business Name",
      accessor: "tradingName",
      Cell: ({ cell }) => {
        const businessName = cell.row.original.business.tradingName;
        return <span>{businessName}</span>;
      },
    },

    {
      Header: "Bill Type",
      accessor: "type",
    },
    {
      Header: "Phone Number",
      accessor: "phone",
      Cell: ({ cell }) => {
        const mobile = cell.row.original.bill.phone;
        return <span>{mobile}</span>;
      },
    },
    {
      Header: "Amount",
      accessor: "amount",
      Cell: ({ cell }) => {
        const amount = cell.row.original.bill.amount;
        const formattedAmount = amountFormatter("NGN").format(amount);
        return <span>{formattedAmount}</span>;
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        const status = cell.value;
        const statusClass = `status ${
          status === "REVERSED"
            ? "status__grey"
            : status === "PAID"
              ? "status__green"
              : "status__dark__yellow"
        }`;
        return <span className={statusClass}>{status}</span>;
      },
    },
    {
      Header: "Vendor",
      accessor: "vendor",
      Cell: ({ cell }) => {
        const vendor = cell.row.original.bill.vendor;
        return <span>{vendor}</span>;
      },
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const item = cell.row.original;
        return (
          <span
            className="tableAction__text"
            onClick={() => {
              goToBillReconModal(item);
            }}
          >
            View More
          </span>
        );
      },
    },
  ];

  return (
    <AppPage pageTitle="Bills Reconciliation">
      <MimaTable
        tableData={tableData}
        tableColumns={tableColumns}
        searchPlaceholder="Search Subscription"
        searchVariant="wide"
        totalItems={data?.data?.totalCounts}
        onLimitChange={onLimitChange}
        isLoading={isLoading}
        isFetching={isFetching}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearchQuery={setSearchQuery}
      />

      {billRecon && (
        <div className="modal">
          <AnimatePresence>
            {billRecon && (
              <ReconBillsModalContainer
                closeModal={closeModal}
                billItem={billItem}
              />
            )}
          </AnimatePresence>
        </div>
      )}
    </AppPage>
  );
};
export default ReconBills;
